import { DocumentTable } from 'modules/components/layer25';
import React from 'react';



export type FolderDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FolderDetailSectionProps) => {

  return (
    <DocumentTable.FC />
  );
};
